import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Alert, Row, Col, Card } from "react-bootstrap";
import { FaMoneyBillWave, FaShoppingBag, FaRupeeSign, FaEnvelopeOpenText, FaUsers, FaUserPlus } from "react-icons/fa";

// Define gradient colors for cards
const gradients = [
  "linear-gradient(135deg, #667eea, #764ba2)",
  "linear-gradient(135deg, #43cea2, #185a9d)",
  "linear-gradient(135deg, #ff9966, #ff5e62)",
  "linear-gradient(135deg, #f7971e, #ffd200)",
  "linear-gradient(135deg, #00c6ff, #0072ff)",
];

const Dashboard = () => {
  // State variables
  const [orders, setOrders] = useState([]);
  const [ordersCount, setOrdersCount] = useState(0);
  const [saleCount, setSaleCount] = useState(0);
const [enquiryCount, setEnquiryCount] = useState(null);
const [memberCount, setMemberCount] = useState(null);
const [pendingAadhaarCount, setPendingAadhaarCount] = useState(0);


  const [userData, setUserData] = useState([]);
  const [counts, setCounts] = useState({
    orders: 0,
    sales: 0,
    enquiry: 0,
    members: 0,
    newMember: 0,
  });
  const [orderNotification, setOrderNotification] = useState([]);
  const [userNotification, setUserNotification] = useState([]);  // Separate user notifications
  const [notifications, setNotifications] = useState([]);

  // Fetch Order Data
  useEffect(() => {
    const fetchOrderData = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/order");
        const orders = res.data?.orders || res.data?.orderData || [];

        const sortedOrders = orders
          .filter((order) =>
            order.date || order.created_at || order.createdAt || order.order_date
          )
          .sort((a, b) => {
            const dateA = a.date || a.created_at || a.createdAt || a.order_date;
            const dateB = b.date || b.created_at || b.createdAt || b.order_date;
            return new Date(dateB) - new Date(dateA);
          });

        setOrders(sortedOrders);
        setOrdersCount(sortedOrders.length);

        const notifications = sortedOrders.map((order) => {
          const orderDate = order.date || order.created_at || order.createdAt || order.order_date;
          return {
            type: "info",
            message: `New Order from: ${order.name} (${order.phone}) on ${new Date(orderDate).toLocaleString()}`,
            orderDetails: order,
          };
        });

        setOrderNotification(notifications);
      } catch (error) {
        console.error("ORDER API ERROR", error);
      }
    };

    fetchOrderData();
  }, []);

  // Fetch User Data
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/userdetail");
        const users = res.data?.data || [];

        const filteredUsers = users.filter(
          (item) =>
            item.aadhaar_verify?.toLowerCase() !== "verified" &&
            item.pan_verify?.toLowerCase() !== "verified"
        );

        const userNotifications = filteredUsers.map((user) => ({
          type: "warning",
          message: `New Member: ${user.name} (${user.phone}) has not verified Aadhaar and/or PAN.`,
          userDetails: user,
        }));

        setUserData(filteredUsers);
        setUserNotification(userNotifications);
      } catch (error) {
        console.error("USER API ERROR", error);
      }
    };

    fetchUserData();
  }, []);

  // Fetch Latest transaction
  useEffect(() => {
    const fetchTranx = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/fetch-tranx");

        const transactions = res.data?.tranxData || [];

        const latestUnverified = transactions
          .filter(
            (t) =>
              t.pay_date &&
              String(t.is_verify).toLowerCase() !== "verified"
          )
          .sort((a, b) => {
            const d1 = new Date(a.pay_date.replace(" ", "T"));
            const d2 = new Date(b.pay_date.replace(" ", "T"));
            return d2 - d1;
          })[0];

        if (!latestUnverified) {
          setNotifications([]);
          return;
        }

        setNotifications([{
          type: "success",
          message: `Latest Transaction: ${latestUnverified.name} | ₹${latestUnverified.amount} | ${latestUnverified.trans_type}`,
        }]);
      } catch (e) {
        console.error("TRANSACTION API ERROR ", e);
        setNotifications([]);
      }
    };

    fetchTranx();
  }, []);

  // Fetch Sales Data
  useEffect(() => {
    const fetchSales = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/order");
        const count = Array.isArray(res.data) 
          ? res.data.length 
          : Array.isArray(res.data?.data) 
          ? res.data.data.length    
          : Array.isArray(res.data?.contacts) 
          ? res.data.contacts.length  
          : 0;
        setSaleCount(count);  
      } catch (err) {   
        console.error("Sales API ERROR", err);   
        setSaleCount(0);    
      }       
    };

    fetchSales();
  }, []);

  // Fetch Enquiries Data
useEffect(() => {
  const fetchEnquiry = async () => {
    try {
      const res = await axios.get("https://api.bigfresh.in/fetch-contact");

      const list =
        res.data?.contactUser ||
        res.data?.data ||
        [];

      setEnquiryCount(Array.isArray(list) ? list.length : 0);
    } catch (err) {
      console.error("Enquiry API ERROR", err);
      setEnquiryCount(0);
    }
  };

  fetchEnquiry();
}, []);


  // Fetch Member Count
  useEffect(() => {
 

  fetchMember();
}, []);

 
 
const fetchMember = async () => {
  try {
    const res = await axios.get("https://api.bigfresh.in/userdetail");

    const list = res.data?.data || res.data?.users || [];

    // Filter users: exclude id=1
    const filteredList = list.filter(user => user.id !== 1);

    // Count of total members (excluding id=1)
    const totalMembers = filteredList.length;

    // Count of members whose aadhaar_verify !== 'Verified'
    const pendingVerification = filteredList.filter(
      user => user.aadhaar_verify !== "Verified"
    ).length;



    setMemberCount(totalMembers); // total members
    setPendingAadhaarCount(pendingVerification); // pending aadhaar
  } catch (err) {
    console.error("Member API ERROR", err);
    setMemberCount(0);
    setPendingAadhaarCount(0);
  }
};



 
 
  const cards = [
    { title: "Recent Orders", value: ordersCount, key: "orders", icon: <FaShoppingBag size={28} />, link: "/orders" },
    // { title: "Total Sale", value: saleCount, key: "sales", icon: <FaRupeeSign size={28} /> },
    { title: "Enquiry", value: enquiryCount, key: "enquiry", icon: <FaEnvelopeOpenText size={28} />, link: "/enquiry" },
    { title: "Total Member", value: memberCount, key: "members", icon: <FaUsers size={28} />, link: "/users" },
    { title: "New Member", value:pendingAadhaarCount, key: "newMember", icon: <FaUserPlus size={28} />,  link: "/users"},
  ];

  // Counter for each card
  useEffect(() => {
    cards.forEach((card) => {
      let cur = 0;
      const end = card.value;
      if (!end) return;

      const timer = setInterval(() => {
        cur++;
        setCounts((p) => ({ ...p, [card.key]: cur > end ? end : cur }));
        if (cur >= end) clearInterval(timer);
      }, 40);
    });
  }, [ordersCount, saleCount, enquiryCount, memberCount]);

  // UI Render
  return (
    <>
      <h3 className="fw-bold text-center mb-4">Admin <span className="text-success">Dashboard</span></h3>

      {/* Cards Section */}
      <Row className="g-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
        {cards.map((card, i) => (
          <Col key={card.key}>
            {card.link ? (
              <Link to={card.link} style={{ textDecoration: "none" }}>
                <Card
                  className="text-white h-100"
                  style={{
                    background: gradients[i % gradients.length],
                    borderRadius: "16px",
                    cursor: "pointer",
                  }}
                >
                  <Card.Body>
                    <div className="d-flex justify-content-between">
                      <h6>{card.title}</h6>
                      {card.icon}
                    </div>
                    <h3 className="fw-bold mt-3">{counts[card.key]}</h3>
                  </Card.Body>
                </Card>
              </Link>
            ) : (
              <Card
                className="text-white h-100"
                style={{
                  background: gradients[i % gradients.length],
                  borderRadius: "16px",
                }}
              >
                <Card.Body>
                  <div className="d-flex justify-content-between">
                    <h6>{card.title}</h6>
                    {card.icon}
                  </div>
                  <h3 className="fw-bold mt-3">{counts[card.key]}</h3>
                </Card.Body>
              </Card>
            )}
          </Col>
        ))}
      </Row>

      <h4 className="mt-2 fw-bold text-success">Recents</h4>

      {/* Order Notifications */}
      {orderNotification.length > 0 && (
        <div className="order-notification-strip mt-4">
          {orderNotification.map((notification, index) => (
            <Link key={index} to="/orders" style={{ textDecoration: "none" }}>
              <Alert variant={notification.type} className="position-relative mt-2" style={{ cursor: "pointer" }}>
                {notification.message}

                <FaShoppingBag
                  size={26}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                  }}
                />
              </Alert>
            </Link>
          ))}
        </div>
      )}

      {/* User Notifications */}
      {userNotification.length > 0 && (
        <div className="user-notification-strip mt-4">
          {userNotification.map((notification, index) => (
            <Link key={index} to="/users" style={{ textDecoration: "none" }}>
              <Alert variant={notification.type} className="position-relative fade-in mt-2" style={{ transition: "all 0.3s ease-out", marginBottom: "10px", boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", cursor: "pointer" }}>
                <span>{notification.message}</span>

                <FaUserPlus
                  size={26}
                  color="#ddb904"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                  }}
                />
              </Alert>
            </Link>
          ))}
        </div>
      )}

     {/* Latest Transaction Notification */}
{notifications.length > 0 ? (
  notifications.map((n, i) => (
    <Link key={i} to="/transaction" style={{ textDecoration: "none" }}>
      <Alert key={i} variant={n.type}>
        {n.message}
        <FaMoneyBillWave
          size={26}
          color="#0e5f1e"
          style={{
            position: "absolute",
            top: "50%",
            right: "15px",
            transform: "translateY(-50%)",
          }}
        />
      </Alert>
    </Link>
  ))
) : (
  <Alert variant="success">
    No unverified transactions found
  </Alert>
)}


      
    </>
  );
};

export default Dashboard;
